import theme from "../../theme"

const styles = {
  tab: {
    width: {
      xs: '33.3%',
      sm: 'inherit',
    },
  },
  badge: {
    '& .MuiBadge-badge': {
      position: 'relative',
      transform: 'none',
      ml: 1,
    },
  },
  incidentBox: {
    padding: theme.spacing(2)
  },
}

export default styles
